import { message } from "antd";
import { observable, action, flow } from "mobx";
import {
	getAccounts,
	deleteAccounts,
	addAccount
} from "services/accountProfile";
import { registerHandler, delay } from "services/api";

class AccountsStore {
	@observable accounts = [];
	@observable profile = {};
	@observable ui = {};

	constructor() {
		this.ui = this.initUI();
	}

	initUI = () => {
		const ui = {
			loadingAccounts: false,
			deletingAccounts: false,
			newAccount: null,
			updatedAccount: null,
			deletedAccounts: [],
			importedAccounts: [],
			currentAccount: null,
			addingAccount: false,
			renamingAccount: false,
			addEditAccountDialogVisible: false,
			importingAccounts: false
		};

		return observable.object(ui);
	};

	@action
	startImportingAccounts = () => {
		this.ui.importingAccounts = true;
	}

	@action
	completeImportingAccounts = () => {
		this.ui.importingAccounts = false;
	}
	
	remoteDeleteAccounts = flow(function*(accountIds) {
		// let willBeDeletedAccounts = [];
		// for (let i = this.accounts.length - 1; i >= 0; i--)  {
		//     let account = this.accounts[i];
		//     if (account.checked) {
		//         willBeDeletedAccounts.push({
		//             accountListId: account.accountListId,
		//             siteName: account.siteName,
		//             email: account.email
		//         })
		//     }
		// }
		const response = yield deleteAccounts(this.profile.id, accountIds);

		if (response == null) {
			message.error("Failed to delete the accounts", 5);
			return;
		}

		if (response.error) {
			message.error(response.error.message, 5);
			return;
		}

		message.success("Successfully deleted the accounts", 3);

		// for (let i = this.accounts.length - 1; i >= 0; i--) {
		// 	let account = this.accounts[i];
		// 	if (account.checked) {
		// 		this.accounts.splice(i, 1);
		// 	}
		// }
	});

	@action
	deleteAccounts = deletedAccounts => {
		this.ui.deletedAccounts = observable.array(deletedAccounts);
	};

	@action
	addAccount = account => {
		this.ui.newAccount = observable.object(account);
	};

	@action
	updateAccount = updatedAccount => {
		this.ui.updatedAccount = observable.object(updatedAccount);
	};

	@action
	importAccounts = importedAccounts => {
		this.ui.importedAccounts = observable.array(importedAccounts);
	};

	@action
	showAddAccountDialog = () => {
		this.ui.currentAccount = null;
		this.ui.addEditAccountDialogVisible = true;
	};

	@action
	hideAddEditAccountDialog = () => {
		this.ui.currentAccount = null;
		this.ui.addEditAccountDialogVisible = false;
	};

	remoteAddAccount = flow(function*(account) {
		this.ui.currentAccount = observable.object(account);

		this.ui.addingAccount = true;

		const response = yield addAccount({
			...account,
			accountListId: this.profile.id
		});

		this.ui.addingAccount = false;

		if (response == null) {
			message.error("Failed to add new account", 5);
			return;
		}

		if (response.error) {
			message.error(response.error.message, 5);
			return;
		}

		message.success("Successfully added account", 5);
		this.ui.addEditAccountDialogVisible = false;
		this.ui.currentAccount = null;
		return;
	});

	fetchAccounts = flow(function*(accountProfileId) {
		this.ui.loadingAccounts = true;

		const response = yield getAccounts(accountProfileId);

		this.ui = this.initUI();

		if (response == null) {
			message.error("Failed to get the accounts. Unknown error", 5);
			return;
		}

		if (response.error) {
			message.error(response.error.message, 5);
			return;
		}

		this.campaign = observable.object(response.campaign);
		this.profile = observable.object(response.profile);
		this.accounts = observable.array(response.accounts);

		registerHandler([
			{
				path: "profile/" + accountProfileId,
				handler: (err, msg) => {
					if (err) {
						return;
					}
					var obj = JSON.parse(msg.body);

					if (obj.action == "newAccount") {
						this.addAccount(obj.account);
						return;
					}
					if (obj.action == "accountsDeleted") {
						this.deleteAccounts(obj.accounts);
						return;
					}
					if (obj.action == "accountEdited") {
						this.updateAccount(obj.account);
					}
					if (obj.action == "accountsImported") {
						this.importAccounts(obj.accounts);
					}
				}
			}
		]);
		message.success("Successfully load the accounts", 5);
		return;
	});
}

export default AccountsStore;
